import React from 'react';

import Urls from '../../../config/index';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Popconfirm, Button, Modal, Form, Pagination, Row, Col,Upload,Icon } from 'antd';
import Serach from '../../utils/serach';
import Add from '../../utils/add';
import Edit from '../../utils/edit';
import Head from '../../utils/head';
import request from '../../utils/request';
import { paramsEncode } from '../../utils/index';
import { connect } from 'react-redux';

const FormItem = Form.Item;

let getDeviceUrl = Urls.LocalResourceUrl.list;
let modify = Urls.LocalResourceUrl.modify;
let find = Urls.LocalResourceUrl.selectById;
let uploadUrl = Urls.LocalResourceUrl.upload;

//export default class extends React.Component {
class LocalResource extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            list: [],
            serach: {
                page: 1,
                pageSize: 10,
            },
            resourceIds: [],
        };
        this.onChange = this.onChange.bind(this);
        this.handleRefresh = this.handleRefresh.bind(this);
        //注意这里要绑定上  在head.js中才可直接调用handDeleteResourceByIds方法
        this.handDeleteResourceByIds = this.handDeleteResourceByIds.bind(this);
    }
    componentWillMount() {
        this.getList(getDeviceUrl + paramsEncode(this.state.serach));
    }

    getList(url) {
        (async url => {
            try {
                let response = await request(url);
                this.setState(Object.assign(this.state, response));
            } catch (e) {
                message.error(e.message);
            }
        })(url);
    }

    confirm(record) {
        let url = Urls.LocalResourceUrl.delete;
        (async url => {
            try {
                let response = await request(url, 'delete', record);
                message.success('删除成功');
                this.handleRefresh(); //删除完成重新刷新网页
            } catch (e) {
                console.log(e);
                message.error('删除失败');
            }
        })(url);
    }

    onChange(current, pageSize) {
        let _serach = Object.assign(this.state.serach, { page: current, pageSize: pageSize });
        this.setState(Object.assign(this.state, { serach: _serach }));
        this.getList(getDeviceUrl + paramsEncode(this.state.serach));
    }

    serach(serach) {
        //记录搜索文本
        let _serach = Object.assign(this.state.serach, serach, { page: 1 }); //page = 1
        this.setState(Object.assign(this.state, { serach: _serach }));
        (async url => {
            try {
                let response = await request(url);
                this.state.list = response.list;
                this.setState(Object.assign(this.state, response));
            } catch (e) {
                console.log(e);
                message.error('查询失败');
            }
        })(getDeviceUrl + paramsEncode(this.state.serach));
    }

    handleRefresh() {
        let _serach = Object.assign(this.state.serach, { page: 1 });
        this.setState(Object.assign(this.state, { serach: _serach }));
        this.getList(getDeviceUrl + paramsEncode(this.state.serach));
        this.state.resourceIds = [];
    }

    onSelectChange = selectedRowKeys => {
        //console.log("selectedRowKeys-value",selectedRowKeys);
        this.setState({
            resourceIds: selectedRowKeys
        })
   }

   //批量删除
    handDeleteResourceByIds() {
       
        //console.log('要删除的素材ids2',this.state.resourceIds);
        let deleteIds =  this.state.resourceIds;
        let deleteResouceByIdsUrl = Urls.LocalResourceUrl.deleteResouceByIds;
        (async (deleteResouceByIdsUrl,deleteIds) => {
            try {
                //response是返回的data的值
                let response = await request(deleteResouceByIdsUrl, 'post', deleteIds);
                message.success('批量删除成功');            
            } catch (e) {
                console.log(e);
                message.error('批量删除失败');
            }
        })(deleteResouceByIdsUrl,deleteIds);
        //刷新列表
        this.handleRefresh();
        //清空选中的
        this.state.resourceIds = [];
    }

    render() {
        const rowSelection = {
            selectedRowKeys: this.state.resourceIds,//selectedRowKeys选中的数据id集合
            onChange: this.onSelectChange,//点击任何一个可选框都可触发此方法
        };
        const propsImg = {
            name: 'file',
            action: uploadUrl,
            onChange(info) {
            alert('上传完成');
            window.location.reload();//强制刷新页面
         },
        };
        let metadata = [
            {
                type: 'Input',
                placeholder: 'resId',
                addonBefore: 'resId',
                field: 'resId',
            },
        ];
        let addMetas = [
            {
                type: 'Input',
                placeholder: 'resId',
                label: 'resId',
                isRequired: true,
                field: 'resId',
            },
            {
                type: 'Input',
                placeholder: '#amp#间隔',
                label: 'clkURL',
                isRequired: false,
                field: 'clkURL',
            },
            {
                type: 'Input',
                placeholder: 'dplURL',
                label: 'dplURL',
                isRequired: false,
                field: 'dplURL',
            },
            {
                type: 'Input',
                placeholder: 'hrefURL',
                label: 'hrefURL',
                isRequired: false,
                field: 'hrefURL',
            },
            {
                type: 'Input',
                placeholder: '#amp#间隔',
                label: 'impURL',
                isRequired: false,
                field: 'impURL',
            },
            {
                type: 'Input',
                placeholder: '#amp#间隔',
                label: 'timePairs',
                isRequired: true,
                field: 'timePairs',
            },
            {
                type: 'Input',
                placeholder: 'execDate',
                label: 'execDate',
                isRequired: false,
                field: 'execDate',
            },
            {
                type: 'Input',
                placeholder: 'iosDplURL',
                label: 'iosDplURL',
                isRequired: false,
                field: 'iosDplURL',
            },
            {
                type: 'Input',
                placeholder: 'androidDplUR',
                label: 'androidDplUR',
                isRequired: false,
                field: 'androidDplUR',
            },
        ];
        const columns = [
            {
                title: 'resId',
                dataIndex: 'resId',
                key: 'resId',
            },
            {
                title: 'clkURL',
                dataIndex: 'clkURL',
                key: 'clkURL',
            },
            {
                title: 'dplURL',
                dataIndex: 'dplURL',
                key: 'dplURL',
            },
            {
                title: 'hrefURL',
                dataIndex: 'hrefURL',
                key: 'hrefURL',
            },
            {
                title: 'impURL',
                dataIndex: 'impURL',
                key: 'impURL',
            },
            {
                title: 'timePairs',
                dataIndex: 'timePairs',
                key: 'timePairs',
            },
            {
                title: 'execDate',
                dataIndex: 'execDate',
                key: 'execDate',
            },
            {
                title: 'iosDplURL',
                dataIndex: 'iosDplURL',
                key: 'iosDplURL',
            },
            {
                title: 'androidDplUR',
                dataIndex: 'androidDplUR',
                key: 'androidDplUR',
            },
            {
                title: '操作',
                key: 'action',
                render: record => (
                    <span>
                        <Edit
                            metadata={addMetas}
                            url={modify}
                            find={find + '' + record._id}
                            handleRefresh={this.handleRefresh}
                        />
                        <span className="ant-divider" />
                        <Popconfirm title="是否删除?" onConfirm={this.confirm.bind(this, record)}>
                            <a href="#">删除</a>
                        </Popconfirm>
                    </span>
                ),
            },
        ];
        return (
            <div>
                <h2>素材数据列表</h2>
                <Row className="searchRow">
                    <Head
                        serachMeta={metadata}
                        addMeta={addMetas}
                        addUrl={modify}
                        uploadUrl={uploadUrl}
                        handleRefresh={this.handleRefresh}
                        handleSerach={this.serach.bind(this)}

                        resourceIds={this.state.resourceIds}//传删除的ids
                        handDeleteResourceByIds = {this.handDeleteResourceByIds}//传处理方法
                    />
                   
                    {/* <Upload {...propsImg}  fileList={ this.props.fileList} style={{marginLeft: '20px'}}>
                                        <Button type="primary">
                                            <Icon type="upload" /> 上传
                                        </Button>
                                    </Upload> */}
                 
                </Row>
                
              
                <Table columns={columns} dataSource={this.state.list} pagination={false} bordered  
                rowSelection={rowSelection} 
                rowKey="_id"/>
                <Pagination
                    showQuickJumper
                    showSizeChanger
                    current={this.state.serach.page}
                    total={this.state.total}
                    className="ant-table-pagination"
                    onChange={this.onChange}
                    onShowSizeChange={this.onChange}
                />
            </div>
        );
    }
}
export default connect()(Form.create()(LocalResource));



// WEBPACK FOOTER //
// ./components/sider/localResource.js